/* eslint-disable import/no-named-as-default */
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _toLower from 'lodash/toLower'
import _get from 'lodash/get'
import _merge from 'lodash/merge'
import { get as getConfig } from '../../../config/index'
import { getLocalPreferences, setLocalPreferences } from '../../../services/local-preferences/index'
import { TYPE_LOGIN, TYPE_GIFT_CREATE_ACCOUNT } from '../../../services/dialog/index'
import { format as formatDateTime } from '../../../services/date-time/index'
import { useTranslation } from '../../../services/static-text/hooks'
import { URL_GIFT_REDEEM } from '../../../services/url/constants'
import { pushHistory } from '../../../services/navigation/actions'
import { setOverlayDialogVisible, renderModal } from '../../../services/dialog/actions'
import { historyRedirect } from '../../../services/navigation/index'
import {
  selectGiftRedeemProcessing,
  selectGiftRedeemSuccess,
  selectGiftTokenError,
  selectGiftDetails,
  selectGiftIsExpired,
} from '../../../services/gift/selectors'
import { selectAuth } from '../../../services/auth/selectors'
import { getAuthIsLoggedIn } from '../../../services/auth/index'
import { selectLocale } from '../../../services/page/selectors'
import { selectPrimaryLanguage } from '../../../services/user/selectors'
import { setUserDataLanguage } from '../../../services/user/actions'
import { H2 } from '../../Heading/index'
import { GIFT_REDEEM_PAGE_STATIC_KEY } from './gift-redeem-page-static-key'
import GiftSectionGreeting from './GiftSectionGreeting'
import GiftSectionRedeem from './GiftSectionRedeem'

const config = getConfig()
const giftMultipleCurrenciesActive = !!_get(config, ['features', 'gift', 'multipleCurrencies'])

export function GiftRedeemPage ({ location, history }) {
  const dispatch = useDispatch()
  const auth = useSelector(selectAuth)
  const isLoggedIn = getAuthIsLoggedIn(auth)
  const redeemProcessing = useSelector(selectGiftRedeemProcessing)
  const translateByKey = useTranslation(GIFT_REDEEM_PAGE_STATIC_KEY)
  const redeemed = useSelector(selectGiftRedeemSuccess)
  const giftTokenError = useSelector(selectGiftTokenError)
  const gift = useSelector(selectGiftDetails)
  const hasBeenRedeemed = !!gift.get('redeemedAt')
  const isExpired = useSelector(selectGiftIsExpired)
  const locale = useSelector(selectLocale)
  const [createModalRendered, setCreateModalRendered] = useState(false)
  const recipientFirstName = gift.get('recipientFirstName')
  const translationKeyTitle = recipientFirstName
    ? 'titlePersonalized' : 'titleANON'
  const userLanguage = useSelector(selectPrimaryLanguage)
  const giftLanguage = gift.get('language')

  const translate = (key, data) => translateByKey(key, data)
  const formatDate = (date) => formatDateTime(date, locale, 'YYYY-MM-DD')
  const formatRedeemDate = (date) => formatDateTime(date, locale, 'MM-DD-YYYY')
  const onLogin = () => dispatch(setOverlayDialogVisible(TYPE_LOGIN))
  const onTokenEntered = ({ token: t }) => dispatch(pushHistory({
    query: { token: t }, url: URL_GIFT_REDEEM, scrollToTop: true,
  }))
  // eslint-disable-next-line max-len
  const onCreateAccount = () => {
    setCreateModalRendered(true)
    dispatch(renderModal(TYPE_GIFT_CREATE_ACCOUNT, {
      onDismiss: () => setCreateModalRendered(false),
    }))
  }

  useEffect(() => {
    if (createModalRendered && redeemProcessing) {
      dispatch(renderModal(TYPE_GIFT_CREATE_ACCOUNT, {
        hideDismiss: redeemProcessing,
        onDismiss: () => setCreateModalRendered(false),
      }))
    }
  }, [createModalRendered, redeemProcessing, dispatch])

  useEffect(() => {
    if (
      !isLoggedIn
      && giftLanguage
      && giftLanguage !== userLanguage
      && giftMultipleCurrenciesActive
    ) {
      const localUserData = getLocalPreferences(-1, 'user') || {}
      const updatedDataLanguage = {
        data: {
          language: _toLower(giftLanguage),
        },
      }
      const mergedUserData = _merge(localUserData, updatedDataLanguage)

      dispatch(setUserDataLanguage(_toLower(giftLanguage)))
      setLocalPreferences(-1, 'user', mergedUserData, auth)
      historyRedirect({
        url: URL_GIFT_REDEEM,
        query: location.query,
        language: _toLower(giftLanguage),
        history,
        auth,
      })
    }
  }, [giftLanguage, dispatch, userLanguage, isLoggedIn])

  return (
    <div className="gift-redeem">
      <div className="gift-redeem__content">
        {!hasBeenRedeemed && !isExpired && (
          <div className="gift-redeem__heading">
            <H2>{translate(translationKeyTitle, { recipientFirstName })}</H2>
            <p>{translate('gaiaVisionAndMission')}</p>
          </div>
        )}
        <div className="gift-redeem__body">
          <GiftSectionGreeting
            onTokenEntered={onTokenEntered}
            formatDate={formatDate}
            translate={translate}
            gift={gift}
          />
          {redeemed || giftTokenError
            ? null
            : <GiftSectionRedeem
            onCreateAccount={onCreateAccount}
            isLoggedIn={isLoggedIn}
            formatDate={formatRedeemDate}
            translate={translate}
            location={location}
            onLogin={onLogin}
            gift={gift}
          />}
        </div>
      </div>
    </div>
  )
}

export default GiftRedeemPage
